// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__K0qXu","closeButton":"styles_closeButton__bDeRZ","title":"styles_title__ZHC7Z","container":"styles_container__444BG"};